import PropTypes from 'prop-types';
import React from 'react';

import { SvgIcon } from '@mui/material';
import { isNil } from 'lodash';

const IconClose = ({ height, width }) => (
  <SvgIcon
    focusable="false"
    viewBox={!isNil(height) && !isNil(width) ? `0 0 ${width} ${height}` : '0 0 27 26'}
    aria-hidden="true"
    width={width || '27'}
    height={height || '26'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      width: !isNil(width) ? `${width}px` : 'inherit',
      height: !isNil(height) ? `${height}px` : 'inherit',
    }}
  >
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="31.2076"
        height="5"
        rx="2"
        transform="matrix(-0.718625 -0.695398 -0.695398 0.718625 26.7964 22.1274)"
        fill="white"
      />
      <rect
        x="1.09619"
        y="22.1274"
        width="31.2076"
        height="5"
        rx="2"
        transform="rotate(-44.059 1.09619 22.1274)"
        fill="white"
      />
    </svg>
  </SvgIcon>
);

IconClose.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default IconClose;
